import React from 'react';
import DateResponse from './date-response';
import TimeResponse from './time-response';
import EmailResponse from './email-response';
import { useTranslation } from 'react-i18next';
import NumberResponse from './number-response';
import UploadReseponse from './upload-response';
import CheckboxResponse from './checkbox-response';
import DropdownResponse from './dropdown-response';
import AddUsersResponse from './add-users-response';
import DateTimeResponse from './date-time-response';
import CountriesResponse from './countries-response';
import ParagraphResponse from './paragraph-response';
import ShortTextResponse from './short-text-response';
import SignatureReseponse from './signature-response';
import PhoneNumberResponse from './phone-number-response';
import AddCalculationResponse from './add-calculation-response';
import MultipleDropdownResponse from './multiple-dropdown-response';
import AddImageResponse from './add-image-response';
import AddDocumentResponse from './add-document-response';
import AddDescriptionResponse from './add-description-response';
import AddTitleResponse from './add-title-response';
import AddURLResponse from './add-url-response';
import AddVideoResponse from './add-video-response';
import FlightPlanResponse from './flight-plan-response';
import { sortSectionQuestions } from '@/utils/sort-form-responses';

interface ResponseResponse {
  questionId: string;
  questionType: string;
  label: string;
  response: any;
}

interface SectionProps {
  responses: ResponseResponse[] | Record<string, ResponseResponse>;
  formDesign?: any;
  sectionId?: string;
}

const ResponseComponents: { [key: string]: React.FC<{ response: any, label: string }> } = {
  'Short Text': ShortTextResponse,
  'Email': EmailResponse,
  'Phone Number': PhoneNumberResponse,
  'Paragraph': ParagraphResponse,
  'Date': DateResponse, 
  'DateTime': DateTimeResponse, 
  'Time': TimeResponse,
  'Number': NumberResponse,
  'Checkbox': CheckboxResponse,
  'Dropdown': DropdownResponse,
  'Upload': UploadReseponse,
  'Signature': SignatureReseponse,
  'Add Calculation': AddCalculationResponse,
  'Add Users': AddUsersResponse,
  'From Database': MultipleDropdownResponse,
  'Add To Database': MultipleDropdownResponse,
  'Countries': CountriesResponse,
  'Add Image': AddImageResponse,
  'Add Document': AddDocumentResponse,
  'Add Description': AddDescriptionResponse,
  'Add Title': AddTitleResponse,
  'Add URL': AddURLResponse,
  'Add Video': AddVideoResponse,
  'Flight Plan': FlightPlanResponse,
};

const Section: React.FC<SectionProps> = ({ responses, formDesign, sectionId }) => {
  const { t } = useTranslation();
  
  // Sort responses based on form design order
  const responsesArray = sortSectionQuestions(
    responses,
    formDesign,
    sectionId || ''
  );
  
  return (
    <div className="mb-6 space-y-4">
      {responsesArray.map(({ questionType, label, response, questionId }, index) => {
        const ResponseComponent = ResponseComponents[questionType] || (() => <div>{t('formResponses.unknownResponseType')}</div>);
        // const isCheckbox = questionType === 'Checkbox';
        return (
          <div key={questionId || index}>
            <p className="font-medium text-textmain pb-1">{label}</p>
            <ResponseComponent key={questionId || index} response={response} label={label} />
          </div>
        );
      })}
    </div>
  );
};

export default Section;
